import React, {
  forwardRef,
  useImperativeHandle,
  useEffect,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
//components
import Input from "../../../input/Input";
import Select from "../../../input/Select";
import MultipleSelect from "../../../input/MultipleSelect";
//services
import { getSendEmail } from "../../../../services/GeneralRegistration/getSendEmail";
import { fetchCanAccess } from "../../../../services/GeneralRegistration/getCanAccess";
import { fetchCanRegistrationTypes } from "../../../../services/GeneralRegistration/getCanRegistrationTypes";
//context
import { useAppContext } from "../../../../context/AppContext";
import { toast } from "react-toastify";
import Toggle from "../../../button/Toggle";

export const Access = forwardRef(
  (
    {
      onSubmitAccess,
      access,
      onDirty,
      editClient,
      baseData,
      emailSend,
      emailVerify,
      showInputCreci,
      setShowInputCreci,
      setShowStatusUser,
      showInputCrc,
      showStatusUser,
      setShowInputCrc,
    },
    ref
  ) => {
    const {
      control,
      handleSubmit,
      setValue,
      getValues,
      formState: { errors, isDirty, dirtyFields: changedValues },
    } = useForm();
    const { permissions } = useAppContext();
    const [statusUser, setStatusUser] = useState(false);
    const [loadingEmail, setLoadingEmail] = useState(false);
    const [inputRequireds, setInputRequireds] = useState([]);
    const { data: canAccessQuery, isLoading: loadingCanAccess } = useQuery({
      queryKey: ["canAccess"],
      queryFn: () => fetchCanAccess(),
    });
    const canAccess = canAccessQuery
      ? canAccessQuery.data?.map((dado) => ({
          value: dado.id,
          label: dado.name,
        }))
      : [];

    const { data: typesregistrationQuery, isLoading: loadingTypes } = useQuery({
      queryKey: ["canRegistrationTypes"],
      queryFn: () => fetchCanRegistrationTypes(),
    });

    const typesregistrationMultiSelect = typesregistrationQuery
      ? typesregistrationQuery.data?.map((dado) => ({
          name: dado.name,
          code: dado.id,
        }))
      : [];

    const sendRetryEmail = async (id) => {
      // console.log(id);
      setLoadingEmail(true);
      try {
        await getSendEmail(id);
        toast.success("E-mail enviado com sucesso");
      } catch (error) {
        toast.error("Erro a enviar e-mail");
      }
      setLoadingEmail(false);
    };

    const handleRegistrationTypesChange = async (e) => {
      const auxTypeRegister = e.some(
        (item) => item.code === 1 || item.code === 2 || item.code === 8
      );

      const itemsSelected = e.map((item) => {
        return item.name;
      });

      if (
        itemsSelected.includes("Corretor") ||
        itemsSelected.includes("Imobiliária")
      ) {
        setShowInputCreci(true);
      } else {
        setShowInputCreci(false);
      }

      if (itemsSelected.includes("Contador")) {
        setShowInputCrc(true);
      } else {
        setShowInputCrc(false);
      }

      if (auxTypeRegister) {
        var auxRegisterGeneral = localStorage.getItem("registerGeneral");
        setInputRequireds(auxRegisterGeneral);
        localStorage.setItem("required_registerGeneral", true);
      } else {
        setInputRequireds([]);
        localStorage.setItem("required_registerGeneral", false);
      }
    };
    
    const handleInputRequireds = () => {
      const auxRegisterGeneral = localStorage.getItem("registerGeneral");
      setInputRequireds(auxRegisterGeneral);
    };
    
    const getFormErrorMessage = (name) => {
      return errors[name] ? (
        <small className="p-error">{errors[name].message}</small>
      ) : (
        <small className="p-error">&nbsp;</small>
      );
    };
    
    useImperativeHandle(ref, () => ({
      submit: () => handleSubmit(onSubmitAccess)(),
      getValues: () => getValues(),
    }));

    useEffect(() => {
      onDirty?.(isDirty);
    }, [isDirty]);

    useEffect(() => {
      if (onSubmitAccess) {
        Object.keys(onSubmitAccess).forEach((key) => {
          setValue(key, onSubmitAccess[key]);
        });
      }
    }, [onSubmitAccess, setValue]);

    useEffect(() => {
      if (access) {
        console.log("access", access);
        setShowStatusUser(true);
        Object.keys(access).forEach((key) => {
          setValue(key, access[key]);
        });
      }
    }, [access]);

    useEffect(() => {
      handleInputRequireds();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      if (baseData) {
        console.log("bd", baseData);
        if (baseData.pivot) {
          setValue("registration_types", [{ name: "Cliente", code: 1 }]);
        }
        setValue("email", baseData.email);
        setValue("confirmEmail", baseData.email);
      }
    }, [baseData, setValue]);


    return (
      <>
        <form onSubmit={handleSubmit(onSubmitAccess)}>
          <div className="row justify-content-end">
            {showStatusUser &&
              permissions &&
              permissions.includes("12") && ( //Editar status
                <div className="col-md-3 mt-2 ps-5">
                  <Toggle
                    name="status"
                    onLabel="Usuário Ativo"
                    offLabel="Usuário Inativo"
                    control={control}
                    onChange={(e) => setStatusUser(e)}
                    className={
                      statusUser === false ? "bg-red-400 rounded-pill" : "bg-success rounded-pill"
                    }
                    getFormErrorMessage={getFormErrorMessage}
                  />
                </div>
              )}
          </div>
          <div className="row">
            <div
              className={
                canAccess?.length === 0 ? "col-md-4 my-2" : "col-md-6 my-2"
              }
            >
              <MultipleSelect
                name="registration_types"
                label="Tipo de Cadastro"
                control={control}
                options={typesregistrationMultiSelect}
                disabled={loadingTypes ? true : false}
                onChange={handleRegistrationTypesChange}
              />
            </div>
            {canAccess?.length > 0 && (
              <div className={"col-md-6 my-2"}>
                <Select
                  name="access_id"
                  label="Grupo de Acesso"
                  errors={errors}
                  control={control}
                  options={canAccess ? canAccess : []}
                  disabled={loadingCanAccess ? true : false}
                />
              </div>
            )}
            <div
              className={
                canAccess?.length === 0 ? "col-md-4 my-2" : "col-md-6 my-2"
              }
            >
              <div className="p-inputgroup mt-4" style={{ height: "60%" }}>
                {editClient && emailSend && !changedValues.email ? (
                  <>
                    <Input
                      name="email"
                      disabled={emailVerify}
                      errors={errors}
                      control={control}
                      // onChange={() => form.set}
                      type="email"
                      validationRules={{
                        pattern: {
                          value:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                          message: "E-mail inválido.",
                        },
                      }}
                      isRequired={inputRequireds.includes("email")}
                      label={`E-mail ${
                        inputRequireds.includes("email") ? "*" : ""
                      }`}
                    />
                    {permissions &&
                      !emailVerify &&
                      permissions.includes("163") && ( //Nova tentativa de envio email primeiro acesso
                        <Button
                          // loading={loadingCupom}
                          type="button"
                          loading={loadingEmail}
                          icon="fa-regular fa-paper-plane"
                          tooltipOptions={{ position: "top" }}
                          tooltip="Reenviar Solicitação de Senha"
                          onClick={() => sendRetryEmail(editClient)}
                        />
                      )}
                  </>
                ) : (
                  <Input
                    name="email"
                    disabled={emailVerify}
                    errors={errors}
                    control={control}
                    // onChange={() => form.set}
                    type="email"
                    validationRules={{
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "E-mail inválido.",
                      },
                    }}
                    isRequired={inputRequireds.includes("email")}
                    label={`E-mail ${
                      inputRequireds.includes("email") ? "*" : ""
                    }`}
                  />
                )}
              </div>
            </div>
            <div
              className={
                canAccess?.length === 0 ? "col-md-4 my-2" : "col-md-6 my-2"
              }
            >
              <Input
                errors={errors}
                control={control}
                disabled={emailVerify}
                type="email"
                validationRules={{
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "E-mail inválido.",
                  },
                  required: inputRequireds.includes("email")
                    ? "Este campo é obrigatório."
                    : "",
                }}
                name="confirmEmail"
                label={`Digite novamente o email ${
                  inputRequireds.includes("email") ? "*" : ""
                }`}
                isRequired={inputRequireds.includes("email")}
              />
            </div>
            {showInputCreci && (
              <div className="col-md-6">
                <Input
                  isRequired
                  errors={errors}
                  control={control}
                  name="creci"
                  label={`Creci *`}
                  validationRules={{
                    minLength: {
                      value: 4,
                      message: "O valor deve ter no mínimo 4 caracteres.",
                    },
                  }}
                />
              </div>
            )}
            {showInputCrc && (
              <div className="col-md-6">
                <Input
                  isRequired
                  errors={errors}
                  control={control}
                  name="crc"
                  label={`CRC *`}
                />
              </div>
            )}
          </div>
        </form>
      </>
    );
  }
);
